import { Injectable } from '@angular/core';
import { QuotationDetail, QuotationModule } from './domain.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {
  public quotationDetail: QuotationDetail = undefined;

  constructor() { }
}
